import { createUserWithEmailAndPassword, User, UserCredential } from "firebase/auth";
import { auth, db } from "../Database/Firebase.service";
import { doc, getDoc, setDoc } from "firebase/firestore";

export const createNewUser = async (email: string, password: string): Promise<User | null> => {
    try {
        const userCredential: UserCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user: User = userCredential.user;
        return user;    
    } catch (error) {
        console.error(error);
        return null;
    }
}

export const createUserDoc = async (name: string, user: User, role: string = "User"): Promise<void> => {
    try {
        const firestore = db;
        const userDocRef = doc(firestore, "Users", user.uid);
        const docSnap = await getDoc(userDocRef);

        if(!docSnap.exists()){
            await setDoc(userDocRef, {
                displayName: name,
                email: user.email,
                role
            });
            return;
        }
        
        await setDoc(userDocRef, { role }, {merge: true});
    } catch (error) {
        console.error(`Erro ao atualizar nivel de permissao do usuario: ${error}`)
    }
}